import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Stockmovement } from 'services/action';

import { Page, Button } from 'ui/components';
import { FormInput, FormItems } from './component/form';

const initialState = {
  isLoading: true,
  form: null,
  items: [],
};

const CreateScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const selectedWarehouse = useSelector((state) => state?.Auth?.selectedWarehouse);

  const [{ form, items, isLoading }, setState] =
    React.useState(initialState);

  const $handleSubmit = async () => {
    const payload = {
      warehouse_id: selectedWarehouse?.id,
      destination_id: form?.destination?.id || '',
      schedule_at: form?.schedule_at?.formatted,
      note: form?.note,
      ...items,
    };

    const req = await Dispatch(Stockmovement.$create(payload));

    if (req?.message === 'success') {
      History?.push(`/inventory/stockmovement/${req?.data?.id}`);
    }
  };

  const $handleItemsChange = async (e) => {
    setState((prevState) => ({ ...prevState, items: e }));
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);


  return (
    <Page type="form" className="col-md-8 bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Buat Stockmovement" />
      <Page.Body className="d-block px-3 py-3">
        <div className="row">
          <FormInput isLoading={isLoading} onInputChange={(e) => setState((prevState) => ({ ...prevState, form: e }))} />
          <FormItems isLoading={isLoading} onItemChange={$handleItemsChange} />
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/inventory/stockmovement`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;
